/* ==========================================================================
   TotalPantofi — CARD EXTRAS JS
   1) Clickable product image area
   2) "Nouă colecție" badge for products < 365 days old
   ========================================================================== */
(function () {
  'use strict';

  var MS_730_DAYS = 730 * 24 * 60 * 60 * 1000;  // 2 ani — pragul de "noua colectie"
  var TAG_NEW = 'noua-colectie';                 // tag Shopify: adauga-l pe orice produs pentru badge fortat

  /* Make card media clickable — but do NOT interfere with links/buttons inside */
  function makeCardClickable(card) {
    if (card.dataset.tpClickable === '1') return;
    if (!card.dataset.productUrl) return;
    var url = card.dataset.productUrl;

    // Click handler — navigates to product unless a real interactive element was clicked
    card.addEventListener('click', function (e) {
      // If the user clicked on a real <a>, <button>, <input>, form control, or quick-add — let it be
      var interactive = e.target.closest(
        'a, button, input, select, label, [role="button"], .te-fav, ' +
        '.quick-add, .quick-add__submit, .card__badge, .tp-discount-pct, ' +
        'product-form, quick-order-list-remove-button, .cart-remove-button'
      );
      if (interactive) return;
      // Middle / Ctrl / Cmd click → open in new tab
      if (e.ctrlKey || e.metaKey || e.button === 1) {
        window.open(url, '_blank', 'noopener');
        return;
      }
      window.location.href = url;
    });

    // Keyboard: focus within card + Enter navigates
    card.tabIndex = card.tabIndex >= 0 ? card.tabIndex : 0;
    card.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var inField = e.target.closest('input, textarea, select, [contenteditable]');
      if (inField) return;
      var isBtn = e.target.closest('button, a');
      if (isBtn) return;
      window.location.href = url;
    });

    card.dataset.tpClickable = '1';
  }

  /* Add "Nouă colecție" badge if:
     - Produsul are tag-ul "noua-colectie" (override manual — indiferent de data), SAU
     - A fost publicat/creat in ultimii 730 de zile (2 ani) */
  function addNewBadge(card) {
    if (card.querySelector('.tp-new-badge')) return;

    // Tag-based override: tag "noua-colectie" pe produs → badge intotdeauna
    var tags = (card.dataset.tags || '').toLowerCase();
    var hasTag = tags.split(',').some(function (t) { return t.trim() === TAG_NEW; });

    if (!hasTag) {
      // Fallback: verificare dupa data publicare/creare
      var published = parseInt(card.dataset.publishedAt || '0', 10);
      var created = parseInt(card.dataset.createdAt || '0', 10);
      var refTs = Math.max(published, created);
      if (!refTs) return;
      var ageMs = Date.now() - refTs * 1000;
      if (ageMs < 0 || ageMs > MS_730_DAYS) return;
    }

    // "Noua Colectie" sta mereu in top-left.
    // Daca exista deja un discount % pill in top-left (.tp-discount-pct), o mutam in top-right.
    // Sale badge-ul Shopify ("LA PRET REDUS") este in bottom-left, deci NU se suprapune cu top-left.
    var hasDiscount = card.querySelector('.tp-discount-pct');

    var badge = document.createElement('span');
    badge.className = 'tp-new-badge';
    if (hasDiscount) badge.classList.add('tp-new-badge--right');
    badge.innerHTML =
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M12 2l2.39 5.26L20 8l-4.6 3.9L17 18l-5-3-5 3 1.6-6.1L4 8l5.61-.74L12 2z"/>' +
      '</svg>' +
      '<span>Colectia Noua</span>';

    // Place on the media container so it floats over the image
    var media = card.querySelector('.card__media, .card .media') || card;
    if (getComputedStyle(media).position === 'static') {
      media.style.position = 'relative';
    }
    media.appendChild(badge);
  }

  function enhanceCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.card-wrapper[data-product-url]');
    cards.forEach(function (c) {
      makeCardClickable(c);
      addNewBadge(c);
    });
  }

  /* Observe DOM for new cards (collection filters re-render, infinite scroll etc.) */
  function observe() {
    if (!('MutationObserver' in window)) return;
    var debounce;
    var mo = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { enhanceCards(); }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* PDP — inject "Nouă colecție" badge if product is < 365 days old */
  function addPdpNewBadge() {
    if (document.querySelector('.tp-new-badge--pdp')) return;
    var pub = document.querySelector('meta[name="tp-product-published"]');
    var cre = document.querySelector('meta[name="tp-product-created"]');
    var publishedTs = pub ? parseInt(pub.getAttribute('content'), 10) : 0;
    var createdTs = cre ? parseInt(cre.getAttribute('content'), 10) : 0;
    var refTs = Math.max(publishedTs, createdTs);
    if (!refTs) return;
    var ageMs = Date.now() - refTs * 1000;
    if (ageMs < 0 || ageMs > MS_730_DAYS) return;

    var badge = document.createElement('span');
    badge.className = 'tp-new-badge tp-new-badge--pdp';
    badge.innerHTML =
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M12 2l2.39 5.26L20 8l-4.6 3.9L17 18l-5-3-5 3 1.6-6.1L4 8l5.61-.74L12 2z"/>' +
      '</svg>' +
      '<span>Colectia Noua</span>';

    // Prefer placing ABOVE the vendor/brand line or at the start of the info container
    var target =
      document.querySelector('.product__text.caption-with-letter-spacing') ||
      document.querySelector('.product__info-container .product__text') ||
      document.querySelector('.product__title') ||
      document.querySelector('.product__info-wrapper');
    if (!target) return;
    target.parentNode.insertBefore(badge, target);
  }

  function init() {
    enhanceCards();
    addPdpNewBadge();
    observe();
    document.addEventListener('shopify:section:load', function () {
      enhanceCards();
      addPdpNewBadge();
    });
    document.addEventListener('tp:grid-updated', function () { enhanceCards(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
